import { GridCard } from "../components/GridCard";
import "../css/dashboard.css";
import { UserLanguage } from "../lang/lang";

export const Dashboard = () => (
  <div className="cardgrid">
    <GridCard
      to="/customer/orders"
      title={UserLanguage().pages.customerOrder.list}
      icon="th-list"
    />
    <GridCard
      to="/articles/view"
      title={UserLanguage().pages.dashboard.article_view}
      icon="layout-hierarchy"
    />
    <GridCard
      to="/articles/all"
      title={UserLanguage().pages.dashboard.all_articles}
      icon="barcode"
    />
  </div>
);
